import styled from 'styled-components';

export const CharacterBlock = styled.article`
  margin: 1rem;
  border: 1px solid var(--cloudGrey);
  border-radius: 0.5rem;
  overflow: hidden;
  box-shadow: 0 0.5rem 2rem -1rem rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  width: 320px;
  height: 124px;

  img {
    object-fit: cover;
    object-position: 0 25%;
    width: 100px;
  }

  .details {
    padding: 0 0.75rem;

    h5 {
      margin: 0 0 0.25rem 0;
      font-size: rem;
    }

    p {
      margin: 0;
    }
  }
`;
